import React from 'react';

import CustomSelect from 'components/CustomSelect/CustomSelect';
import { useUserInfoContext } from 'components/UserInfoProvider/UserInfoProvider';

interface Props {
  inputProps?: any;
}

const PaymentMethodSelector: React.FC<Props> = ({
  inputProps = {},
}) => {
  const { userInfo } = useUserInfoContext();

  React.useEffect(() => {
    if (inputProps.value) return;

    // If no initial payment method id is set, set it to the default payment method the user has
    const defaultPaymentMethodId = userInfo?.agentInfo?.stripe?.paymentMethods?.find((o: any) => o.isDefault)?.id;
    if (defaultPaymentMethodId) inputProps.onChange({ target: { value: defaultPaymentMethodId } });
  }, [userInfo]);

  // Don't show an empty selector if there are no payment methods
  if (!userInfo?.agentInfo?.stripe?.paymentMethods?.length) return null;

  return (
    <CustomSelect
      labelText="Choose Payment Method"
      items={userInfo?.agentInfo?.stripe?.paymentMethods?.map((pm: any) => ({
        value: pm.id,
        name: `${pm.brand?.toUpperCase()} ending in ${pm.last4} - Expires ${pm.expMonth?.toString().padStart(2, '0')}/${pm.expYear}`,
      })) ?? []}
      inputProps={{
        ...inputProps,
      }}
    />

  );
};

export default PaymentMethodSelector;
